import React, { useState, useRef, useEffect } from 'react';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const ChipStack = ({ useRelativePositioning = false }) => {
  const [showChips, setShowChips] = useState(false);
  const [isVisible, setIsVisible] = useState(false); // For managing animation visibility
  const chipContainerRef = useRef(null);

  // Toggle chips visibility with fade-in
  const handleInfoClick = () => {
    setIsVisible(true); // Start fade-in animation
    setShowChips(true); // Show chips
  };

  // Hide chips on click outside with fade-out
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chipContainerRef.current && !chipContainerRef.current.contains(event.target)) {
        setIsVisible(false); // Start fade-out animation
        setTimeout(() => setShowChips(false), 300); // Wait for fade-out to complete before hiding the chips
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [chipContainerRef]);

  const chips = [
    { title: 'Roads', color: '#009DDC' },
    { title: 'Boundaries', color: '#FFD02C' },
    { title: 'Unstoppable Zone', color: 'black', isDashed: true }
  ];

  // When useRelativePositioning is true, don't use fixed positioning
  const iconButtonStyle = useRelativePositioning
    ? { backgroundColor:'rgba(255,255,255,0.3)' }
    : { position: 'fixed', bottom: '40px', left: '40px', backgroundColor:'rgba(255,255,255,0.3)' };

  const chipContainerStyle = useRelativePositioning
    ? {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 1000,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        position: 'fixed',
        bottom: '40px',
        left: '40px',
        zIndex: 1000,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
      };

  return (
    <div>
      {!showChips && (
        <IconButton
          onClick={handleInfoClick}
          style={iconButtonStyle}
          size="large">
          <InfoIcon style={{ fontSize: '40px', color: '#009DDC' }} />
        </IconButton>
      )}
      {showChips && (
        <div
          ref={chipContainerRef}
          style={chipContainerStyle}
        >
          {chips.map((chip, index) => (
            <div
              key={index}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '10px 20px',
                border: `2px ${chip.isDashed ? 'dashed' : 'solid'} ${chip.color}`,
                backgroundColor: 'rgba(255, 255, 255,0.7)',
                borderRadius: '16px',
                color: chip.color === '#FFD02C' ? 'black' : chip.color,
                fontWeight: 'bold',
                width: 'fit-content',
              }}
            >
              {chip.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChipStack;
